import React from "react";
import { Outlet } from "react-router-dom";

import Wrapper from "../components/Wrapper";
import Main from "../components/Main";
import Content from "../components/Content";
import Footer from "../components/Footer";

const BlankLayout = ({ children }) => (
  <React.Fragment>
    <Wrapper>
      <Main>
        <Content>
          {children}
          <Outlet />
        </Content>
        <Footer />
      </Main>
    </Wrapper>
  </React.Fragment>
);

export default BlankLayout;
